import { VIEWS } from "../contract.js";
import { medicationsView } from "./medications.js";
import { noteReviewView } from "./note-review.js";
import { orderView } from "./order.js";
import { resultsView } from "./results.js";
import { reviewConfirmView } from "./review-confirm.js";

/** Every Careline view by `ui://` resource URI (`VIEWS`, which the manifest's tools declare). One resource per view: `tool-input` does not carry the tool name. */
export const careLineViews: Readonly<Record<string, string>> = {
  [VIEWS.noteReview]: noteReviewView,
  [VIEWS.reviewConfirm]: reviewConfirmView,
  [VIEWS.results]: resultsView,
  [VIEWS.medications]: medicationsView,
  [VIEWS.order]: orderView,
};
